import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {filter, map, mergeMap} from 'rxjs/operators';
import {EventsService} from '@services/events.service';
import {DataEventsService} from '@services/data-events.service';
import {ApplicationConfigService} from '@services/application-config.service';
import {ScrollToService} from '@services/scroll-to.service';
import {PreviewModalService} from '@services/preview-modal.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    public userTitle: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private events: EventsService,
        /**
         * Импорты, чтобы инициализировать сервисы на самом старте
         */
        private appConfig: ApplicationConfigService,
        private dataEvents: DataEventsService,
        private filesPreviewService: PreviewModalService,
    ) {}

    ngOnInit() {
        /**
         * Гайд Todd Motto по изменению title страницы через передачу data: {title: 'value'} в роутинге
         * https://toddmotto.com/dynamic-page-titles-angular-2-router-events
         */
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data),
        )
            .subscribe((event: any) => {
                /**
                 * Подматываем к началу страницы если явно не указано этого не делать
                 */
                if (event && (!('scrollTop' in event) || event['scrollTop'] !== false)) {
                    ScrollToService.toTop();
                }

                /**
                 * Скрываем все уведомления с таймером при переходе между страницами
                 */
                this.events.notyHideOnRouteChange$.next();
            });

        /**
         * Смена title страницы
         */
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            /**
             * Доходим до самой "глубокой/вложенной" открытой страницы
             */
            map((route) => {
                while (route && route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => Boolean(route && route.snapshot && route.snapshot.data)),
            /**
             * Берем первый заголовок у страницы, к которой он есть, поднимаясь вверх по родительским страницам
             */
            map((route) => {
                /**
                 * Почему-то в некоторых ситуациях filter пропускает сюда route === null
                 */
                while (route && route.snapshot && !route.snapshot.data.title) {
                    route = route.parent;
                }
                return route && route.snapshot && route.snapshot.data.title;
            })
        ).subscribe((routeTitle: string) => {
            this.titleService.setTitle(routeTitle || 'Lab365');
        });
    }
}
